import React, { Component } from 'react';
import classNames from 'classnames'
import { connect } from 'react-redux';

import { Skeleton } from 'primereact/skeleton';
import { Button } from 'primereact/button';

import Header from '@components/Header';

import htmlTemplates from '@staticTemplate/htmlTemplates'

import { mainClassForSection } from '@utils/general'

import { SET_VALUES_SECTION } from '@constants/actionType'

import store from '@store'

import './style.scss';


class NewSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      btnSubmitLoading: false,
      layoutSelected: null,
    };
  }

  componentDidMount() {
    // Validar si viene
    const { history, layoutId } = this.props
    console.log(history)
    // if ()
    this.setState({layoutSelected: layoutId})
  }

  selectLayout = (typeLayout) => {
    console.log(typeLayout);
    this.setState({layoutSelected: typeLayout})
  };

  inspectLayout = () => {
    const { layoutSelected } = this.state
    const { history } = this.props
    if (!layoutSelected) return true
    this.setState({btnSubmitLoading: true})
    const _htmlTemplate = htmlTemplates.find(item => item.id === layoutSelected)
    const formatHtml = document.createElement( 'html' );
    formatHtml.innerHTML = _htmlTemplate.templete
    console.log(formatHtml)
    const getAllClass = Array.from(formatHtml.querySelectorAll('[class]')).flatMap(e => e.className.toString().split(/\s+/))
    console.log('getAllClass', getAllClass)
    // const catalogParentClass = ['banner-section', 'about-section', 'our-services-section']
    const findClassBySections = getAllClass.reduce((accum, item) => {
      const existClass = mainClassForSection().indexOf(item)
      if (existClass !== -1) accum.push(item)
      return accum
    }, [])
    console.log('----> filterClassSections', findClassBySections)
    


    // START Obtener elemento y setear algo
    // const hasInformation = formatHtml.getElementsByClassName('about-title')
    // console.log('hasInformation', hasInformation)
    // hasInformation[0].innerHTML = 'Hola golalalalalalallala @@@@@@@'
    // END Obtener elemento y setear algo

    // console.log(formatHtml)

    
    // Crear catalogo de las clases 
    //titulo
    //Clase primaria
    //Subclases
    //Nombre de componente
    
    // Crear vista para los pasos dinamicos
    // Apartir de catalogParentClass.length se inician los pasos
    // Obtener el primero elemento y obtener su titulo
    // Obtener su componente
    
    // Componente de formulario 
      // Debera obtener su initialValues

      // Iniciar la vista con los valores en redux
      // @isRemove: Se puede remover la seccion, Boolean
      // @valueRemove: Valor a validar para remover la seccion, Boolean
      // @isImg: Es referente a etiqueta img, Boolean
      // @children: Tiene un 3 nivel de clases (como la cards o como los acordiones)
      // const catalogoClass = [
        //   {
          //     titleSection: 'Banner',
          //     parentClass: {
            //       class: 'banner-section',
            //       childrenClass: [
              //         { class: 'banner-title', valueState: 'banner.title' },
              //         { class: 'about-description', valueState: 'banner.description' },
              //         { class: 'banner-btn-left', valueState: 'banner.btnLeftText', isRemove: true, valueRemove: 'banner.hasBntLeft' },
              //         { class: 'banner-btn-rigth', valueState: 'banner.btnRigthText', isRemove: true, valueRemove: 'banner.hasBntRigth' },
              //         { class: 'banner-background-img', valueState: 'banner.backgroundImg', isImg: true  },
              //       ]
              //     }
              //   },
              //   {
                //     titleSection: 'Acerca de nosotros',
    //     parentClass: {
      //       class: 'about-section',
      //       childrenClass: [
        //         { class: 'about-title', valueState: 'about.title' },
    //         { class: 'about-description', valueState: 'about.description' },
    //       ]
    //     }
    //   },
    //   {
      //     titleSection: 'Acerca de nosotros',
      //     parentClass: {
        //       class: 'about-section',
        //       childrenClass: [
          //         { class: 'about-title', valueState: 'about.title' },
          //         { class: 'about-description', valueState: 'about.description' },
          //       ]
          //     }
          //   },
          //   {
            //     titleSection: 'Nuestros servicios',
            //     parentClass: {
              //       class: 'our-services-section',
              //       childrenClass: [
                //         { class: 'sevice-title', valueState: 'cards.title' },
                //         { class: 'our-services-cards-content', valueState: 'about.description', children: [
                  //           { class: 'our-services-card-tittle', valueState: 'cards.title' },
                  //           { class: 'our-services-card-link', valueState: 'cards.link' },
                  //           { class: 'our-services-card-description', valueState: 'cards.description' }
                  //         ] },
                  //       ]
                  //     }
                  //   },
                  // ]
                  // // Hacer logica para las cards dinamicas
                  // const State ={
                    //       about: {
                      //         title: 'Acerca de nosotros',
                      //         description: 'Nosotros somos una empresa lider tecnologica'
                      //       },
                      //       banner: {
                        //         title: 'Hey',
                        //         description: 'Conoce mas acerca de nosotros',
                        //         hasBntLeft: true,
                        //         btnLeftText: 'Conoce',
                        //         hasBntRigth: false,
                        //         btnRigthText: '',
                        //         backgroundImg: ['File']
                        //       },
                        //       cards: {
    //         title: 'Acerca de nosotros',
    //         cards: [
    //           {
      //             title: 'Conoce',
      //             link: 'google.com',
      //             description: 'Lorem Ipsum'
      //           }
      //         ]
      //       },
      // }
      
      // Se tendra que considerar con multiples idiomas la estructura
      // Los documentos seran direfentes para cada pais
      //Los idiomas seran administrables dinamicamente
      // Si --- Yo tendria que validar automaticamente la estructura dinamicamente segun los paises para cada componente y entonces tendria que pensar nueva estructura
      
      // Si se sube un nuevo layout con los componentes existentes no hay problema
      // Pero si se sube un layout con nuevo componente entonces ahi si tendriamos que agregar nuestras validaciones en el codigo y mapear esa una seccion nueva (crear componente de captura, agregar al catalogo de mapeo de clases, agregar states en estado global, añadir validaciones)

      store.dispatch({
        type: SET_VALUES_SECTION,
        payload: {
          layoutId: layoutSelected,
          mainClass: findClassBySections,
          totalSteps: findClassBySections.length
        }
      })
      this.setState({btnSubmitLoading: false})
      history.push('/section/new/steps')
    }

  render() {
    const { btnSubmitLoading, layoutSelected } = this.state;

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title="Nueva sección" linkText="Ir al listado" to="#" />
          <div className="card">
            <div className="p-grid">
              <div className="p-col-12">
                <h4>Elige un template</h4>
              </div>
              <div className="p-col-4 ">
                <div
                  onClick={() => this.selectLayout(1)}
                  aria-hidden="true"
                  className={classNames('card-layout-border-custom p-p-3', {
                    'layout-selected': layoutSelected === 1
                  })}
                >
                  <label>Fusion</label>
                  <Skeleton className="p-mb-2" borderRadius="16px" />
                  <Skeleton
                    width="10rem"
                    className="p-mb-2"
                    borderRadius="16px"
                  />
                  <Skeleton
                    width="5rem"
                    borderRadius="16px"
                    className="p-mb-2"
                  />
                  <Skeleton
                    height="2rem"
                    className="p-mb-2"
                    borderRadius="16px"
                  />
                  <Skeleton width="10rem" height="4rem" borderRadius="16px" />
                </div>
              </div>
              <div className="p-col-4 ">
                <div
                  onClick={() => this.selectLayout(2)}
                  aria-hidden="true"
                  className={classNames('card-layout-border-custom p-p-3', {
                    'layout-selected': layoutSelected === 2
                  })}
                >
                  <label>Smart</label>
                  <Skeleton className="p-mb-2" borderRadius="16px" />
                  <Skeleton
                    width="10rem"
                    className="p-mb-2"
                    borderRadius="16px"
                  />
                  <Skeleton
                    width="5rem"
                    borderRadius="16px"
                    className="p-mb-2"
                  />
                  <Skeleton
                    height="2rem"
                    className="p-mb-2"
                    borderRadius="16px"
                  />
                  <Skeleton width="10rem" height="4rem" borderRadius="16px" />
                </div>
              </div>
              <div className="p-col-4 ">
                <div
                  onClick={() => this.selectLayout(4)}
                  aria-hidden="true"
                  className={classNames('card-layout-border-custom p-p-3', {
                    'layout-selected': layoutSelected === 4
                  })}
                >
                  <Skeleton className="p-mb-2" borderRadius="16px" />
                  <Skeleton
                    width="10rem"
                    className="p-mb-2"
                    borderRadius="16px"
                  />
                  <Skeleton
                    width="5rem"
                    borderRadius="16px"
                    className="p-mb-2"
                  />
                  <Skeleton
                    height="2rem"
                    className="p-mb-2"
                    borderRadius="16px"
                  />
                  <Skeleton width="10rem" height="4rem" borderRadius="16px" />
                </div>
              </div>
              <div className="p-col-4 ">
                <div
                  onClick={() => this.selectLayout('basic_template_4')}
                  aria-hidden="true"
                  className={classNames('card-layout-border-custom p-p-3', {
                    'layout-selected': layoutSelected === 'basic_template_4'
                  })}
                >
                  <Skeleton className="p-mb-2" borderRadius="16px" />
                  <Skeleton
                    width="10rem"
                    className="p-mb-2"
                    borderRadius="16px"
                  />
                  <Skeleton
                    width="5rem"
                    borderRadius="16px"
                    className="p-mb-2"
                  />
                  <Skeleton
                    height="2rem"
                    className="p-mb-2"
                    borderRadius="16px"
                  />
                  <Skeleton width="10rem" height="4rem" borderRadius="16px" />
                </div>
              </div>
              <div className="p-col-4 ">
                <div
                  onClick={() => this.selectLayout('basic_template_5')}
                  aria-hidden="true"
                  className={classNames('card-layout-border-custom p-p-3', {
                    'layout-selected': layoutSelected === 'basic_template_5'
                  })}
                >
                  <Skeleton className="p-mb-2" borderRadius="16px" />
                  <Skeleton
                    width="10rem"
                    className="p-mb-2"
                    borderRadius="16px"
                  />
                  <Skeleton
                    width="5rem"
                    borderRadius="16px"
                    className="p-mb-2"
                  />
                  <Skeleton
                    height="2rem"
                    className="p-mb-2"
                    borderRadius="16px"
                  />
                  <Skeleton width="10rem" height="4rem" borderRadius="16px" />
                </div>
              </div>
              <div className="p-col-4 ">
                <div
                  onClick={() => this.selectLayout('basic_template_6')}
                  aria-hidden="true"
                  className={classNames('card-layout-border-custom p-p-3', {
                    'layout-selected': layoutSelected === 'basic_template_6'
                  })}
                >
                  <Skeleton className="p-mb-2" borderRadius="16px" />
                  <Skeleton
                    width="10rem"
                    className="p-mb-2"
                    borderRadius="16px"
                  />
                  <Skeleton
                    width="5rem"
                    borderRadius="16px"
                    className="p-mb-2"
                  />
                  <Skeleton
                    height="2rem"
                    className="p-mb-2"
                    borderRadius="16px"
                  />
                  <Skeleton width="10rem" height="4rem" borderRadius="16px" />
                </div>
              </div>
              <div className="p-col-4 ">
                <div
                  onClick={() => this.selectLayout('basic_template_7')}
                  aria-hidden="true"
                  className={classNames('card-layout-border-custom p-p-3', {
                    'layout-selected': layoutSelected === 'basic_template_7'
                  })}
                >
                  <Skeleton className="p-mb-2" borderRadius="16px" />
                  <Skeleton
                    width="10rem"
                    className="p-mb-2"
                    borderRadius="16px"
                  />
                  <Skeleton
                    width="5rem"
                    borderRadius="16px"
                    className="p-mb-2"
                  />
                  <Skeleton
                    height="2rem"
                    className="p-mb-2"
                    borderRadius="16px"
                  />
                  <Skeleton width="10rem" height="4rem" borderRadius="16px" />
                </div>
              </div>
              <div className="p-col-4 ">
                <div
                  onClick={() => this.selectLayout('basic_template_8')}
                  aria-hidden="true"
                  className={classNames('card-layout-border-custom p-p-3', {
                    'layout-selected': layoutSelected === 'basic_template_8'
                  })}
                >
                  <Skeleton className="p-mb-2" borderRadius="16px" />
                  <Skeleton
                    width="10rem"
                    className="p-mb-2"
                    borderRadius="16px"
                  />
                  <Skeleton
                    width="5rem"
                    borderRadius="16px"
                    className="p-mb-2"
                  />
                  <Skeleton
                    height="2rem"
                    className="p-mb-2"
                    borderRadius="16px"
                  />
                  <Skeleton width="10rem" height="4rem" borderRadius="16px" />
                </div>
              </div>
              <div className="p-col-12 footer-btn p-mt-5">
                <div className="p-d-flex p-jc-between">
                  <Button
                    label="Cancelar"
                    icon="pi pi-angle-right"
                    iconPos="right"
                    className="p-button-secondary"
                    type="button"
                    onClick={() => {}}
                  />
                  <Button
                    label="Continuar"
                    icon="pi pi-angle-right"
                    iconPos="right"
                    className="p-button-primary"
                    onClick={() => this.inspectLayout()}
                    loading={btnSubmitLoading}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  layoutId: state.section.layoutId
});

export default connect(mapStateToProps, null)(NewSection);